import React from "react";
import { SVGIcons, ImgIcons, Imgbanner } from "../../Helpers/Common";
import { Link } from "react-router-dom";
var SVGIcon = "";
var ImageData = "";

SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));

export function Mobilemenu(props) {
  var homeActive,
    docubytesActive,
    livetvActive,
    watchlistActive,
    profileActive,
    homeActivecolortext,
    docubytesActivecolortext,
    livetvActivecolortext,
    livetvActivecolortext,
    watchlistActivecolortext,
    profileActivecolortext;

  if (props.active == 1) {
    homeActive = "active";
    homeActivecolortext = "red";
  } else if (props.active == 2) {
    docubytesActive = "active";
    docubytesActivecolortext = "red";
  } else if (props.active == 3) {
    livetvActive = "active";
    livetvActivecolortext = "red";
  } else if (props.active == 4) {
    watchlistActive = "active";
    watchlistActivecolortext = "red";
  } else if (props.active == 5) {
    profileActive = "active";
    profileActivecolortext = "red";
  }

  return (
    <div className="mob-menu">
      <ul>
        <li className="dD-block">
          <Link to="/">
            <img
              src={ImageData["docu-bay-white.png"]}
              alt="Logo"
              className="logo"
            />
            <span>&nbsp; &nbsp;</span>
          </Link>
        </li>
        <li>
          <Link to="/" className={homeActive}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
            >
              <path
                d="M5.15 20.522h12.182a3.65 3.65 0 0 0 3.654-3.646V8.88c0-1.32-.661-2.555-1.763-3.287l-5.786-3.85v.001a3.968 3.968 0 0 0-4.393 0l-5.786 3.85a3.948 3.948 0 0 0-1.763 3.286v7.997a3.65 3.65 0 0 0 3.655 3.646zM3.93 8.879c0-.507.255-.982.68-1.263l5.786-3.85a1.526 1.526 0 0 1 1.69 0l5.787 3.85c.423.282.676.756.676 1.263v7.997a1.213 1.213 0 0 1-1.218 1.215H5.15a1.216 1.216 0 0 1-1.219-1.215V8.88z"
                fillRule="nonzero"
                stroke="#121212"
              />
            </svg>
            <span style={{ color: homeActivecolortext }}>Home</span>
          </Link>
        </li>
        {/*<li>
                  <Link to="/docubyteplay" className = {docubytesActive}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21">
                        <g  fillRule="nonzero">
                            <path d="M10 .5a9.945 9.945 0 0 1 7.07 2.928 9.999 9.999 0 0 1-4.482 16.73 9.999 9.999 0 0 1-9.66-2.587.715.715 0 0 1 0-1.007.715.715 0 0 1 1.007 0A8.57 8.57 0 1 0 10 1.929c-.44.003-.88.039-1.314.107h-.114A.714.714 0 0 1 8.464.614 11.053 11.053 0 0 1 9.999.5zM.822 8.347l.113.01a.713.713 0 0 1 .592.828c-.066.435-.099.874-.1 1.314A.714.714 0 1 1 0 10.5c.002-.518.04-1.036.114-1.55a.71.71 0 0 1 .822-.592zm1.748-4.246a.714.714 0 0 1 .529.149c.313.24.374.686.135 1a8.687 8.687 0 0 0-1.092 1.857.713.713 0 0 1-.672.407.658.658 0 0 1-.286-.064.714.714 0 0 1-.371-.936c.338-.763.768-1.482 1.279-2.143a.718.718 0 0 1 .478-.27zm3.471-2.765a.715.715 0 1 1 .565 1.307A8.716 8.716 0 0 0 4.72 3.72a.72.72 0 0 1-.436.15.714.714 0 0 1-.385-1.257 9.874 9.874 0 0 1 2.142-1.278z"/>
                            <path d="M7.98 13.077V7.88a.454.454 0 0 1 .203-.418.43.43 0 0 1 .456-.009l3.95 2.598a.524.524 0 0 1 .218.427c0 .17-.081.33-.217.427l-3.951 2.598a.43.43 0 0 1-.456-.008.454.454 0 0 1-.204-.418z"/>
                        </g>
                    </svg>
                    <span style={{color:docubytesActivecolortext}}>DocuBytes</span>
                  </Link>
                </li>*/}
 
        <li>
          <Link to="/watch-list" className={watchlistActive}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="21"
              viewBox="0 0 23 21"
            >
              <g fillRule="evenodd">
                <path strokeWidth="1.7" strokeLinecap="round" d="M9 17.5H1" />
                <path
                  d="M16.965 14.214c1.684 0 3.358 1.048 5.042 3.143-1.684 2.095-3.358 3.143-5.042 3.143-1.684 0-3.359-1.048-5.043-3.143 1.684-2.095 3.359-3.143 5.043-3.143zm.713 2.403a.982.982 0 0 0-1.1-.227 1.049 1.049 0 0 0-.622.967c0 .579.452 1.048 1.009 1.048.407 0 .775-.255.931-.646.156-.392.07-.843-.218-1.142z"
                  strokeWidth=".4"
                  fillRule="nonzero"
                />
                <path
                  strokeWidth="1.7"
                  strokeLinecap="round"
                  d="M17 9.5H1M17 1.5H1"
                />
              </g>
            </svg>
            <span>Watchlist</span>
          </Link>
        </li>
        <li className="dD-none">
          <Link to="/profile" className={profileActive}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="23"
              viewBox="0 0 19 23"
            >
              <path
                d="M18.276 21.62c0 .543-.43.982-.963.982a.972.972 0 0 1-.962-.982c0-3.795-3.017-6.873-6.738-6.873-3.72 0-6.738 3.078-6.738 6.873 0 .543-.43.982-.962.982a.972.972 0 0 1-.963-.982c0-4.88 3.879-8.837 8.663-8.837 4.785 0 8.663 3.956 8.663 8.837zm-8.663-9.819c-2.923 0-5.294-2.418-5.294-5.4C4.32 3.418 6.69 1 9.613 1c2.923 0 5.294 2.418 5.294 5.4 0 2.983-2.37 5.401-5.294 5.401zm0-1.964c1.861 0 3.37-1.538 3.37-3.436 0-1.9-1.509-3.437-3.37-3.437-1.861 0-3.369 1.538-3.369 3.437 0 1.898 1.508 3.436 3.37 3.436z"
                fillRule="nonzero"
                strokeWidth=".2"
              />
            </svg>
            <span>Profile</span>
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default Mobilemenu;
